import { useNavigate } from "react-router-dom"
import { translations } from "../../configs/translations"
import { useStore } from "../../store/store"
import './Premium.css'

export interface PremiumProps {
	name: string
	expiresAt?: Date
}

export const Premium = ({ name, expiresAt }: PremiumProps) => {
	const language = useStore((state) => state.language)
	const navigate = useNavigate()
	const t = translations[language]
	const isActivePremium = name && name != 'NONE'


	const getImage = () => {
		switch (name) {
			case 'premium_account': return './icons/128px/premium.png'
			default: return ''
		}
	}

	const getRemainingTimeFormatted = (expiresAt: Date | undefined) => {

		if (!expiresAt || !(expiresAt instanceof Date)) {
			return `0 ${t.days_short}`
		}

		const getRemainingTime = expiresAt.getTime() - new Date().getTime()
		const isExpired = getRemainingTime < 0
		if (isExpired) return `0 ${t.days_short}`

		const hourInMilliseconds = 3600000
		const minutesInMilliseconds = 60000
		const isLessThan1Hour = getRemainingTime < hourInMilliseconds
		if (isLessThan1Hour) return `${Math.floor(getRemainingTime / minutesInMilliseconds)} ${t.minutes_short}`

		const isLessThan1Day = getRemainingTime < 86400000
		if (isLessThan1Day) return `${Math.floor(getRemainingTime / hourInMilliseconds)} ${t.hours_short}`

		const lessThan999Days = getRemainingTime < 999 * 86400000
		if (lessThan999Days) return `${Math.floor(getRemainingTime / 86400000)} ${t.days_short}`

		return `999 ${t.days_short}`
	}

	return (
		<div className="premium-container">
			{isActivePremium && <div className='premium-expiration-container'>
				<img className="premium-expiration-icon" src={getImage()} alt="premium" />
				<p className="premium-expiration-text">{getRemainingTimeFormatted(expiresAt)}</p>
			</div>}
			<div className="premium-account-content-container">
				<p className="account-type">{t[name as keyof typeof t] || t.free_account}</p>
				<a
					className="premium-button"
					onClick={() => navigate('/donate?page=subscription')}
				>
					{isActivePremium ? t.extend_premium : t.upgrade_to_premium}
				</a>
			</div>
		</div>
	)
}